import { createCommonStore } from '@/store/index';

interface UserActivityStore {
  lastActivityTime: number | null;
  lastActivitySyncTime: number | null;

  setLastActivityTime: (lastActivityTime: number) => void;
  setLastActivitySyncTime: (lastActivitySyncTime: number) => void;
}

export const useUserActivityStore = createCommonStore<UserActivityStore>(
  (set) => ({
    lastActivitySyncTime: null,
    lastActivityTime: null,

    setLastActivitySyncTime: (lastActivitySyncTime) => set({ lastActivitySyncTime }),
    setLastActivityTime: (lastActivityTime) => set({ lastActivityTime }),
  }),
  {
    name: 'user-activity-store',
    storage: 'local',
  },
);
